<script>
import {computed} from "vue";
import {useDataSelectStore} from "@/stores/DataSelect";
import useTools from "@/use/Tools";
import {useDelegateStore} from "@/stores/Delegate";
import useSharedMethod from "@/use/SharedMethod";
import {useCountryStateStore} from "@/stores/CountryState";
import {useCountryCityStore} from "@/stores/CountryCity";
import {useProductStore} from "@/stores/Product";
import {useCustomerStore} from "@/stores/Customer";
import {useTeamStore} from "@/stores/Team";
import {useProductRangeStore} from "@/stores/ProductRange";


export default {
    name: "StrFilterButton",
    props: {
        filter: Object,
    },
    setup(props, {emit}) {
        const {$i18n} = useTools();
        const {formatedDate, formatedTime} = useSharedMethod();
        
        const customerStore = useCustomerStore();
        const dataSelectStore = useDataSelectStore();
        const delegateStore = useDelegateStore();
        const countryStateStore = useCountryStateStore();
        const countryCityStore = useCountryCityStore();
        const productStore = useProductStore();
        const teamStore = useTeamStore();
        const productRangeStore = useProductRangeStore();
        
        const display = computed(() => {
            let r = "";
            let list = [];
            let size = 0;
            
            if (props.filter.lastName) {
                r += ` + Nom: ${props.filter.lastName}`;
                list.push({text: 'Nom', value: props.filter.lastName});
                size++;
            }
            if (props.filter.firstName) {
                r += ` + Prénom: ${props.filter.firstName}`;
                list.push({text: 'Prénom', value: props.filter.firstName});
                size++;
            }
            if (props.filter.email) {
                r += ` + Email: ${props.filter.email}`;
                list.push({text: 'Email', value: props.filter.email});
                size++;
            }
            
            if (props.filter.specialityId) {
                const listData = dataSelectStore.dataSelectsSelect['CUSTOMER_SPECIALTY'];
                const item = listData?.find(e => e.id === props.filter.specialityId);
                if (item) {
                    const label = $i18n.t('data_select.CUSTOMER_SPECIALTY');
                    r += ` + ${label}: ${item.name}`;
                    list.push({text: label, value: item.name});
                    size++;
                }
            }
            
            if (props.filter.secondarySpecialityId) {
                const listData = dataSelectStore.dataSelectsSelect['CUSTOMER_SPECIALTY'];
                const item = listData?.find(e => e.id === props.filter.secondarySpecialityId);
                if (item) {
                    const label = "Spécialité Secondaire";
                    r += ` + ${label}: ${item.name}`;
                    list.push({text: label, value: item.name});
                    size++;
                }
            }
            if (props.filter.categoryId && props.filter.type) {
                const listData = dataSelectStore.dataSelectsSelect[`${props.filter.type.toUpperCase()}_CATEGORY`];
                const item = listData?.find(e => e.id === props.filter.categoryId);
                if (item) {
                    const label = $i18n.t(`data_select.${props.filter.type.toUpperCase()}_CATEGORY`);
                    r += ` + ${label}: ${item.name}`;
                    list.push({text: label, value: item.name});
                    size++;
                }
            }
            
            if (props.filter.titleId) {
                const listData = dataSelectStore.dataSelectsSelect['CUSTOMER_TITLE'];
                const item = listData?.find(e => e.id === props.filter.titleId);
                if (item) {
                    const label = $i18n.t('data_select.CUSTOMER_TITLE');
                    r += ` + ${label}: ${item.name}`;
                    list.push({text: label, value: item.name});
                    size++;
                }
            }
            
            if (props.filter.leaderId) {
                const listData = dataSelectStore.dataSelectsSelect['CUSTOMER_LEADER'];
                const item = listData?.find(e => e.id === props.filter.leaderId);
                if (item) {
                    const label = $i18n.t('data_select.CUSTOMER_LEADER');
                    r += ` + ${label}: ${item.name}`;
                    list.push({text: label, value: item.name});
                    size++;
                }
            }
            
            if (props.filter.potentialId) {
                const listData = dataSelectStore.dataSelectsSelect['CUSTOMER_POTENTIAL'];
                const item = listData?.find(e => e.id === props.filter.potentialId);
                if (item) {
                    const label = $i18n.t('data_select.CUSTOMER_POTENTIAL');
                    r += ` + ${label}: ${item.name}`;
                    list.push({text: label, value: item.name});
                    size++;
                }
            }
            
            if (props.filter.doctorTypeId) {
                const listData = dataSelectStore.dataSelectsSelect['CUSTOMER_DOCTOR_TYPE'];
                const item = listData?.find(e => e.id === props.filter.doctorTypeId);
                if (item) {
                    const label = $i18n.t('data_select.CUSTOMER_DOCTOR_TYPE');
                    r += ` + ${label}: ${item.name}`;
                    list.push({text: label, value: item.name});
                    size++;
                }
            }
            
            if (props.filter.clientTypeId) {
                const listData = dataSelectStore.dataSelectsSelect['CUSTOMER_CLIENT_TYPE'];
                const item = listData?.find(e => e.id === props.filter.clientTypeId);
                if (item) {
                    const label = $i18n.t('data_select.CUSTOMER_CLIENT_TYPE');
                    r += ` + ${label}: ${item.name}`;
                    list.push({text: label, value: item.name});
                    size++;
                }
            }
            
            if (props.filter.agreementId) {
                const listData = dataSelectStore.dataSelectsSelect['CUSTOMER_AGREEMENT'];
                const item = listData?.find(e => e.id === props.filter.agreementId);
                if (item) {
                    const label = $i18n.t('data_select.CUSTOMER_AGREEMENT');
                    r += ` + ${label}: ${item.name}`;
                    list.push({text: label, value: item.name});
                    size++;
                }
            }
            
            if (props.filter.cooperationLevelId) {
                const listData = dataSelectStore.dataSelectsSelect['CUSTOMER_COOPERATION_LEVEL'];
                const item = listData?.find(e => e.id === props.filter.cooperationLevelId);
                if (item) {
                    const label = $i18n.t('data_select.CUSTOMER_COOPERATION_LEVEL');
                    r += ` + ${label}: ${item.name}`;
                    list.push({text: label, value: item.name});
                    size++;
                }
            }
            
            if (props.filter.visitLoyaltyStatusId) {
                const listData = dataSelectStore.dataSelectsSelect['VISIT_LOYALTY_STATUS'];
                const item = listData?.find(e => e.id === props.filter.visitLoyaltyStatusId);
                if (item) {
                    const label = $i18n.t('data_select.VISIT_LOYALTY_STATUS');
                    r += ` + ${label}: ${item.name}`;
                    list.push({text: label, value: item.name});
                    size++;
                }
            }
            
            if (props.filter.loyaltyStatusId) {
                const listData = dataSelectStore.dataSelectsSelect['VISIT_LOYALTY_STATUS'];
                const item = listData?.find(e => e.id === props.filter.loyaltyStatusId);
                if (item) {
                    const label = $i18n.t('data_select.VISIT_LOYALTY_STATUS');
                    r += ` + ${label}: ${item.name}`;
                    list.push({text: label, value: item.name});
                    size++;
                }
            }
            
            if (props.filter.visitTypeId) {
                const listData = dataSelectStore.dataSelectsSelect['VISIT_TYPE'];
                const item = listData?.find(e => e.id === props.filter.visitTypeId);
                if (item) {
                    const label = $i18n.t('data_select.VISIT_TYPE');
                    r += ` + ${label}: ${item.name}`;
                    list.push({text: label, value: item.name});
                    size++;
                }
            }
            
            if (props.filter.typeId) {
                const listData = dataSelectStore.dataSelectsSelect['VISIT_TYPE'];
                const item = listData?.find(e => e.id === props.filter.typeId);
                if (item) {
                    const label = $i18n.t('data_select.VISIT_TYPE');
                    r += ` + ${label}: ${item.name}`;
                    list.push({text: label, value: item.name});
                    size++;
                }
            }
            
            if (props.filter.visitAddressClassId) {
                const listData = dataSelectStore.dataSelectsSelect['ADDRESS_CLASS'];
                const item = listData?.find(e => e.id === props.filter.visitAddressClassId);
                if (item) {
                    const label = $i18n.t('data_select.ADDRESS_CLASS');
                    r += ` + ${label}: ${item.name}`;
                    list.push({text: label, value: item.name});
                    size++;
                }
            }
            
            if (props.filter.visitAddressSpecialtyServiceId) {
                const listData = dataSelectStore.dataSelectsSelect['ADDRESS_SPECIALITY_SERVICE'];
                const item = listData?.find(e => e.id === props.filter.visitAddressSpecialtyServiceId);
                if (item) {
                    const label = $i18n.t('data_select.ADDRESS_SPECIALITY_SERVICE');
                    r += ` + ${label}: ${item.name}`;
                    list.push({text: label, value: item.name});
                    size++;
                }
            }
            
            if (props.filter.customerId) {
                const item = customerStore.selectCustomers.find(e => e.id === props.filter.customerId);
                if (item) {
                    r += ` + Médecin: ${item.name}`;
                    list.push({text: 'Médecin', value: item.name});
                    size++;
                }
            }
            
            /*if (props.filter.visitDelegateId) {
                const item = delegateStore.delegates.find(e => e.id === props.filter.visitDelegateId);
                if (item) {
                    r += ` + Délégué: ${item.name}`;
                    list.push({text: 'Délégué', value: item.name});
                    size++;
                }
            }*/

            if (props.filter.territoryByDelegateId) {
                const item = delegateStore.delegates.find(e => e.id === props.filter.territoryByDelegateId);
                if (item) {
                    r += ` + Délégué: ${item.name}`;
                    list.push({text: 'Délégué', value: item.name});
                    size++;
                }
            }

            if (props.filter.productRangeIds && props.filter.productRangeIds.length > 0) {
                const items = props.filter.productRangeIds
                    .map(id => productRangeStore.productRanges.find(e => e.id === id))
                    .filter(Boolean);

                if (items.length > 0) {
                    const allSelected = items.length === productRangeStore.productRanges.length;
                    const names = allSelected ? 'Tous' : items.map(e => e.name).join(', ');
                    r += ` + Gammes: ${names}`;
                    list.push({text: 'Gammes', value: names});
                    size++;
                }
            }
            
            if (props.filter.teamId) {
                const item = teamStore.teams.find(e => e.id === props.filter.teamId);
                if (item) {
                    r += ` + Equipe: ${item.name}`;
                    list.push({text: 'Equipe', value: item.name});
                    size++;
                }
            }
            
            
            if (props.filter.visitProductId) {
                const item = productStore.products.find(e => e.id === props.filter.visitProductId);
                if (item) {
                    r += ` + Produit: ${item.name}`;
                    list.push({text: 'Produit', value: item.name});
                    size++;
                }
            }
            
            if (props.filter.productId) {
                const item = productStore.products.find(e => e.id === props.filter.productId);
                if (item) {
                    r += ` + Produit: ${item.name}`;
                    list.push({text: 'Produit', value: item.name});
                    size++;
                }
            }
            
            
            if (props.filter.visitCountryStateId) {
                const item = countryStateStore.countryStates.find(e => e.id === props.filter.visitCountryStateId);
                if (item) {
                    r += ` + Wilaya: ${item.name}`;
                    list.push({text: 'Wilaya', value: item.name});
                    size++;
                }
            }
            
            if (props.filter.visitCountryCityId) {
                const item = countryCityStore.countryCities.find(e => e.id === props.filter.visitCountryCityId);
                if (item) {
                    r += ` + Commune: ${item.name}`;
                    list.push({text: 'Commune', value: item.name});
                    size++;
                }
            }
            
            
            if (props.filter.countryStateId) {
                const item = countryStateStore.countryStates.find(e => e.id === props.filter.countryStateId);
                if (item) {
                    r += ` + Wilaya: ${item.name}`;
                    list.push({text: 'Wilaya', value: item.name});
                    size++;
                }
            }
            
            if (props.filter.countryCityId) {
                const item = countryCityStore.countryCities.find(e => e.id === props.filter.countryCityId);
                if (item) {
                    r += ` + Commune: ${item.name}`;
                    list.push({text: 'Commune', value: item.name});
                    size++;
                }
            }
            
            if (props.filter.todayVisit) {
                r += ' + Visité Ajourd\'hui';
                list.push({text: 'Visité Ajourd\'hui', value: ""});
                size++;
            }
            
            if (props.filter.hasVisit !== null && props.filter.hasVisit !== undefined) {
                if (props.filter.hasVisit) {
                    r += ' + Visité';
                    list.push({text: 'Visité', value: 'Oui'});
                } else {
                    r += ' + Non Visité';
                    list.push({text: 'Visité', value: 'Non'});
                }
                size++;
            }
            
            if (props.filter.frequency) {
                r += ` + Fréquence Visite: ${props.filter.frequency} fois`;
                list.push({text: 'Fréquence Visite', value: `${props.filter.frequency} fois`});
                size++;
            }
            
            if (props.filter.visitStartDate) {
                r += ` + Date Visite Du: ${formatedDate(props.filter.visitStartDate)}`;
                list.push({text: 'Date Visite Du', value: formatedDate(props.filter.visitStartDate)});
                
                if (props.filter.visitEndDate) {
                    r += ` Au: ${formatedDate(props.filter.visitEndDate)}`;
                    list.push({text: 'Au', value: formatedDate(props.filter.visitEndDate)});
                }
                
                size++;
            }
            
            if (props.filter.startDate) {
                r += ` + Date Visite Du: ${formatedDate(props.filter.startDate)}`;
                list.push({text: 'Date Visite Du', value: formatedDate(props.filter.startDate)});
                
                if (props.filter.endDate) {
                    r += ` Au: ${formatedDate(props.filter.endDate)}`;
                    list.push({text: 'Au', value: formatedDate(props.filter.endDate)});
                }
                
                size++;
            }
            
            if (props.filter.visitStartTime) {
                r += ` + Temps Visite Du: ${formatedTime(props.filter.visitStartTime)}`;
                list.push({text: 'Temps Visite Du', value: formatedTime(props.filter.visitStartTime)});
                
                if (props.filter.visitEndDate) {
                    r += ` Au: ${formatedTime(props.filter.visitEndTime)}`;
                    list.push({text: 'Au', value: formatedTime(props.filter.visitEndTime)});
                }
                
                size++;
            }
            
            
            return {
                size: size,
                text: r,
                list: list,
            };
        });
        
        function click() {
            emit('press');
        }
        
        return {
            display,
            click
        }
    }
}
</script>

<template>
    <v-menu
        open-on-hover
        bottom
        offset-y
    >
        <template v-slot:activator="{ on, attrs }">
            <v-badge
                color="red"
                overlap
                bordered
            >
                <template v-slot:badge>
                    <strong>{{ display.size }}</strong>
                </template>
                <v-btn
                    depressed
                    class="ml-2 white--text"
                    color="blue darken-2"
                    small
                    v-bind="attrs"
                    v-on="on"
                    @click="click"
                >
                    {{ $t('common.filter') }}
                    <v-icon right dark>mdi-filter-plus-outline</v-icon>
                </v-btn>
            </v-badge>
        </template>
        
        <v-card width="800" v-if="display.size > 0">
            <v-container fluid>
                {{ display.text }}
            </v-container>
        </v-card>
    </v-menu>
</template>

<style scoped>

</style>